import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {path: '/', redirect: {name: 'Sites'}},
    {
        path: '/events',
        name: 'Events',
        component: () => import('../views/Events.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/sites',
        name: 'Sites',
        component: () => import('../views/Sites.vue')
    },
    {
        path: '/page_categories',
        name: 'PageCategories',
        component: () => import('../views/PageCategories.vue')
    },
    {
        path: '/pages',
        name: 'Pages',
        component: () => import('../views/Pages.vue')
    },
    {
        path: '/pages/page',
        name: 'Page',
        component: () => import('../views/Pages.vue')
    },
    {
        path: '/site/:site_id/pages',
        name: 'Site Pages',
        component: () => import('../views/Pages.vue')
    },
    {
        path: '/pages/categories/:category_id/pages',
        name: 'Category Pages',
        component: () => import('../views/Pages.vue')
    },
    {
        path: '/markets',
        name: 'Markets',
        component: () => import('../views/Markets.vue')
    },
    {
        path: '/site/:id',
        name: 'Site',
        component: () => import('../views/Site.vue')
    },
    {
        path: '/segments',
        name: 'Segments',
        component: () => import('../views/Segments.vue')
    },
    {
        path: '/categories',
        name: 'Categories',
        component: () => import('../views/Categories.vue')
    },
    {
        path: '/audience',
        name: 'Audience',
        component: () => import('../views/Audience.vue')
    },
    {
        path: '/users',
        name: 'Users',
        component: () => import('../views/Users.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
